import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
    title?: string
}

interface LogoProps {
    className?: string
    markClassName?: string
    wordmarkClassName?: string
}

// The Fieldhand mark: a young sprout, two leaves on a single stem.
export const LogoMark: FC<LogoMarkProps> = ({ className, title }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            fill='currentColor'
            role={title ? 'img' : undefined}
            aria-hidden={title ? undefined : true}
            className={cn('h-8 w-auto shrink-0', className)}
        >
            {title && <title>{title}</title>}
            <path d='M16 29.5V15' fill='none' stroke='currentColor' strokeWidth='3.4' strokeLinecap='round' />
            <path d='M15.2 19.5C8 19.5 3.5 14.6 3.5 7.6c7 0 11.7 4.6 11.7 11.9Z' />
            <path d='M16.8 15.6c0-7.4 4.6-12.1 11.7-12.1 0 7.1-4.5 12.1-11.7 12.1Z' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className, markClassName, wordmarkClassName }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5 text-ink', className)}>
            <LogoMark className={cn('h-[26px] sm:h-[31px]', markClassName)} />

            <span
                className={cn(
                    'font-heading text-[26px] leading-none font-medium tracking-[-0.035em] sm:text-[31px]',
                    wordmarkClassName
                )}
            >
                fieldhand
            </span>
        </span>
    )
}
